<section>
    <div class="row">
        <div class="col-xl-4 col-lg-6 col-md-12">
            <div class="card">
              <div class="card-content">
                <div class="card-header">
                  <h4 class="card-title">Syllabus</h4>
                </div>
                <div class="card-content">
                  <div class="card-body">
                    <img class="img-fluid" src="assets/Syllabus.png" alt="Card image cap">
                  </div>
                </div>
              </div>
              <div class="card-footer pt-0">
                <button class="btn btn-outline-primary" (click)="openInNewTab(slug,user_id)">Go</button>
                <!-- <a class="card-link info darken-2" href="javascript:;">Card link</a>
                <a class="card-link info darken-2" href="javascript:;">Another link</a> -->
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-6 col-md-12">
            <div class="card">
              <div class="card-content">
                <div class="card-header">
                  <h4 class="card-title">Classes</h4>
                </div>
                <div class="card-content">
                  <div class="card-body">
                    <img class="img-fluid" src="assets/Classes.png" alt="Card image cap">
                  </div>
                </div>
              </div>
              <div class="card-footer pt-0">
                <button class="btn btn-outline-primary" (click)="goToClass()">Go</button>
                <!-- <a class="card-link info darken-2" href="javascript:;">Card link</a>
                <a class="card-link info darken-2" href="javascript:;">Another link</a> -->
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-6 col-md-12">
            <div class="card">
              <div class="card-content">
                <div class="card-header">
                  <h4 class="card-title">Sessions</h4>
                </div>
                <div class="card-content">
                  <div class="card-body">
                    <img class="img-fluid" src="assets/Sessions.png" alt="Sessions">
                  </div>
                </div>
              </div>
              <div class="card-footer pt-0">
                <button class="btn btn-outline-primary" (click)="gotoSessions()">Go</button>
                <!-- <a class="card-link info darken-2" href="javascript:;">Card link</a>
                <a class="card-link info darken-2" href="javascript:;">Another link</a> -->
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-6 col-md-12">
            <div class="card">
              <div class="card-content">
                <div class="card-header">
                  <h4 class="card-title">Assignments</h4>
                </div>
                <div class="card-content">
                  <div class="card-body">
                    <img class="img-fluid" src="assets/Assignment.png" alt="Card image cap">
                  </div>
                </div>
              </div>
              <div class="card-footer pt-0">
                <!-- <p style="color: red;">Coming Soon..</p> -->
                <button class="btn btn-outline-primary" routerLink="/assignments/my-assignments">Go</button>
                <!-- <a class="card-link info darken-2" href="javascript:;">Card link</a>
                <a class="card-link info darken-2" href="javascript:;">Another link</a> -->
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-6 col-md-12">
            <div class="card">
              <div class="card-content">
                <div class="card-header">
                  <h4 class="card-title">Grades</h4>
                </div>
                <div class="card-content">
                  <div class="card-body">
                    <img class="img-fluid" src="assets/Grades.png" alt="Card image cap">
                  </div>
                </div>
              </div>
              <div class="card-footer pt-0">
                <button class="btn btn-outline-primary" routerLink="/assignments/grades">Go</button>

                <!-- <p  style="color: red;">Coming Soon..</p> -->
                <!-- <a class="card-link info darken-2" href="javascript:;">Card link</a>
                <a class="card-link info darken-2" href="javascript:;">Another link</a> -->
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-6 col-md-12">
            <div class="card">
              <div class="card-content">
                <div class="card-header">
                  <h4 class="card-title">Projects</h4>
                </div>
                <div class="card-content">
                  <div class="card-body">
                    <img class="img-fluid" src="assets/Projects.png" alt="Card image cap">
                  </div>
                </div>
              </div>
              <div class="card-footer pt-0">
                <button class="btn btn-outline-primary" routerLink="/projects">Go</button>
                <!-- <p  style="color: red;">Coming Soon..</p> -->
                <!-- <a class="card-link info darken-2" href="javascript:;">Card link</a>
                <a class="card-link info darken-2" href="javascript:;">Another link</a> -->
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-6 col-md-12">
            <div class="card">
              <div class="card-content">
                <div class="card-header">
                  <h4 class="card-title">Resources</h4>
                </div>
                <div class="card-content">
                  <div class="card-body">
                    <img class="img-fluid" src="assets/Resources.png" alt="Card image cap">
                  </div>
                </div>
              </div>
              <div class="card-footer pt-0"> 
                <button class="btn btn-outline-primary" routerLink="/all-resources">Go</button>

                <!-- <p  style="color: red;">Coming Soon..</p> -->
                <!-- <a class="card-link info darken-2" href="javascript:;">Card link</a>
                <a class="card-link info darken-2" href="javascript:;">Another link</a> -->
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-6 col-md-12">
            <div class="card">
              <div class="card-content">
                <div class="card-header">
                  <h4 class="card-title">Discussions</h4>
                </div>
                <div class="card-content">
                  <div class="card-body">
                    <img class="img-fluid" src="assets/Discussions.png" alt="Card image cap">
                  </div>
                </div>
              </div>
              <div class="card-footer pt-0">
                <button class="btn btn-outline-primary" routerLink="/discussions/my-discussions">Go</button>
                
                <!-- <p  style="color: red;">Coming Soon..</p> -->
                <!-- <a class="card-link info darken-2" href="javascript:;">Card link</a>
                <a class="card-link info darken-2" href="javascript:;">Another link</a> -->
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-6 col-md-12">
            <div class="card">
              <div class="card-content">
                <div class="card-header">
                  <h4 class="card-title">FAQ & Support</h4>
                </div>
                <div class="card-content">
                  <div class="card-body">
                    <img class="img-fluid" src="assets/FAQ & Support.png" alt="Card image cap">
                  </div>
                </div>
              </div>
              <div class="card-footer pt-0">
                <button class="btn btn-outline-primary" [routerLink]="['/faqs',course_id]">Go</button>

                <!-- <p  style="color: red;">Coming Soon..</p> -->
                <!-- <a class="card-link info darken-2" href="javascript:;">Card link</a>
                <a class="card-link info darken-2" href="javascript:;">Another link</a> -->
              </div>
            </div>
          </div>
    </div>
</section>
